<script>
    import { getContext } from 'svelte';
    import { geoMercator, geoPath } from 'd3-geo';
    
    // --- Properties
    export let dataKey
    const width = 700;
    const height = 500;
    const zoomSpeed = 1.1;
    
    // --- Projection
    const projection = geoMercator()
    .scale(580000)
    .translate([0, 0])
    .rotate([-24.867, -36.069]);    
    const path = geoPath(projection);

    // --- Data
    const {streets, points, hoverIdx, isActive} = getContext(dataKey);
    $: features = $streets.features || [];
    $: coords = $points.map(p => projection([p.long, p.lat]));
        
    // --- Function
    function highlight(i) {
        $hoverIdx = i;
    }

    // --- Viewport / panning / zoom
    let el;
    let panning=false;
    let offset = [0, 0];
    let zoomScale = 1;
    $: viewbox = [
            zoomScale * (-width/2 + offset[0]), 
            zoomScale * (-height/2 + offset[1]),
            zoomScale * width, 
            zoomScale * height 
        ];

    function startPan(_) {
        panning = true;
    }

    function stopPan(_) {
        panning = false;
    }

    function pan(event) {
        if (panning) {
            offset = [
                offset[0] - event.movementX,
                offset[1] - event.movementY
            ];
        }
    }

    function resetView(_) {
        zoomScale = 1;
        offset = [0, 0];
    }

    function zoom(event) {
        if (event.deltaY < 0) {
            zoomScale = Math.min(Math.max(zoomScale / zoomSpeed, 0.1), 2);
        } else {
            zoomScale = Math.min(Math.max(zoomScale * zoomSpeed, 0.1), 2);
        }
    }
</script>


<div bind:this={el} id="map" class='card' style="width:{width}px;height:{height}px;">
    <svg {width} {height}
        viewBox={`${viewbox[0]} ${viewbox[1]} ${viewbox[2]} ${viewbox[3]}`}
        on:mousedown={startPan}
        on:mouseup={stopPan}
        on:mousemove={pan}
        on:mousewheel|preventDefault={zoom}
        on:dblclick={resetView}>
        <g>
            {#each features as street, i}
                <path 
                    fill='transparent'
                    stroke='currentColor'
                    stroke-width=0.5
                    opacity=0.6
                    d={path(street)}
                />
            {/each}
        </g>
        <g>
            {#each $points as point, i} 
                <circle cx={coords[i][0]} 
                        cy={coords[i][1]} 
                        r={4}
                        opacity={$isActive[i] ? 1 : 0.05}
                        fill={`rgb(${point.color[0]*255}, ${point.color[1]*255}, ${point.color[2]*255})`}
                        stroke=1
                        on:mouseenter={() => highlight(i)}
                        on:mouseleave={() => highlight(null)}
                        />
            {/each}
        </g>
    </svg>
</div>

<style>
#map {
    position: relative;
    margin-right: 5px;
}
</style>